// import { render } from "react-dom";
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import './App.css';
// import About from "./components/HomePage/About/About";
import AllBlogs from "./components/HomePage/Blogs/AllBlogs";
// import HomePageBlogs from "./components/HomePage/Blogs/HomePageBlogs";
// import Academic from "./components/HomePage/Academic/Academic";
// import Contact from "./components/HomePage/Contact/Contact";
// import Experience from "./components/HomePage/Experience/Experience";
import HomePage from "./components/HomePage/HomePage/HomePage";
import AllProjects from "./components/HomePage/Projects/AllProjects";
import SingleBlog from "./components/HomePage/SingleBlog/SingleBlog";
import SingleProject from "./components/HomePage/SingleProject/SingleProject";
// import HomePageProjects from "./components/HomePage/Projects/HomePageProjects";
// import Skills from "./components/HomePage/Skills/Skills";
import ResponsiveDrawer from './components/ResponsiveDrawer/ResponsiveDrawer';
import NotFoundPage from "./components/Shared/NotFoundPage/NotFoundPage";

function App() {
  return (
  <BrowserRouter>
  <Routes>
    <Route path="/" element={<ResponsiveDrawer />}>
        <Route  path="/" element={<HomePage />} />
        {/* <Route  path="/home" element={<HomePage />} /> */}
        {/* <Route  path="/About" element={<About />} /> */}
        {/* <Route  path="/Projects" element={<HomePageProjects />} /> */}
        {/* <Route  path="/Experience" element={<Experience />} /> */}
        {/* <Route  path="/Skills" element={<Skills />} /> */}
        {/* <Route  path="/blogs" element={<HomePageBlogs />} /> */}
        {/* <Route  path="/Academic" element={<Academic />} /> */}
        {/* <Route  path="/Contact" element={<Contact />} /> */}
        <Route path="/project/:projectID" element={<SingleProject />} />
        <Route path="/blog/:blogID" element={<SingleBlog />} />
        <Route path="/allblogs" element={<AllBlogs />} />
        <Route path="/allprojects" element={<AllProjects />} />
        <Route path="*" element={<NotFoundPage />}/>
      </Route>
  </Routes>
</BrowserRouter>
  );
}

export default App;


// #531d88

//stripe bahire #F7FAFC
//stripe vitore #FFFFFF

//, nested to hashing convert baki, modal add baki single blog page baki
//.css-1hdvzm3 aita holo sob padding er. kibve remove korebo?